export const GET_ASN_GRN_DEPENDENCY_REQUEST = "GET_ASN_GRN_DEPENDENCY_REQUEST";
export const GET_ASN_GRN_DEPENDENCY_SUCCESS = "GET_ASN_GRN_DEPENDENCY_SUCCESS";
export const GET_ASN_GRN_DEPENDENCY_FAILURE = "GET_ASN_GRN_DEPENDENCY_FAILURE";
